import { render } from "./tianbao.vue?vue&type=template&id=ce8c4e2c&scoped=true"
import script from "./tianbao.vue?vue&type=script&lang=js"
export * from "./tianbao.vue?vue&type=script&lang=js"

import "./tianbao.vue?vue&type=style&index=0&id=ce8c4e2c&scoped=true&lang=css"

import exportComponent from "D:\\AestProject\\EducationOrg\\qianhedu-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce8c4e2c"]])

export default __exports__